import { axios } from '~/common/utils/request'
const commonPath = 'rest/erp/logistics/v3/'

// 出库单列表
export const getOutboundList = params => axios({
  url: `${commonPath}outbound/order/list`,
  method: 'post',
  data: params
})

// 出库单批量确认(履约)
export const batchConfirmOutbound = params => axios({
  url: `${commonPath}outbound/order/confirm`,
  method: 'post',
  data: params
})

// 出库单详情
export const getOutboundInfo = id => axios({
  url: `${commonPath}outbound/order/detail/${id}`,
  method: 'get'
})

// 出库单编辑
export const editOutbound = params => axios({
  url: `${commonPath}outbound/order`,
  method: 'put',
  data: params
})

// 出库单-出库项编辑
export const editOutboundOrder = params => axios({
  url: `${commonPath}outbound/order/line`,
  method: 'put',
  data: params
})

// 出库项-导出
export const exportOutboundLine = params => axios({
  url: `${commonPath}outbound/line/export`,
  responseType: "blob",
  method: 'post',
  data: params
})

// 出库项列表
export const getOutboundLineList = params => axios({
  url: `${commonPath}outbound/line/list`,
  method: 'post',
  data: params
})

// 生成发货项
export const generateShippingLine = params => axios({
  url: `${commonPath}outbound/shipping/line`,
  method: 'post',
  data: params
})

// 出库项详情
export const getOutboundLineInfo = id => axios({
  url: `${commonPath}outbound/line/detail/${id}`,
  method: 'get'
})

// 出库项编辑
export const editOutboundLine = params => axios({
  url: `${commonPath}outbound/line`,
  method: 'put',
  data: params
})

// 出库项批量确认
export const confirmOutboundLine = params => axios({
  url: `${commonPath}outbound/line/batch`,
  method: 'put',
  data: params
})

// 出库项批量确认(履约)
export const batchConfirmOutboundLine = params => axios({
  url: `${commonPath}outbound/shipping/confirm`,
  method: 'post',
  data: params
})

// 单合并生成发货单
export const mergeShipping = params => axios({
  url: `${commonPath}outbound/order/shipping`,
  method: 'post',
  data: params
})

// 项合并生成发货单
export const lineMergeShipping = params => axios({
  url: `${commonPath}outbound/line/shipping`,
  method: 'post',
  data: params
})
